import React, {Component} from 'react';

import { cf } from './cf';
import { ce } from './ce';
import { ic } from './ic';
import { bf } from './bf';

import cView from './cView';

class cCpyList extends cView {
  //
  $id_stgs = { //  子で上書き
  };
  //
  $cd_stss = { // 親を上書き
    sld_cm20ss: {},
  };

  $clp_loads = () => [ // 親を上書き
    //
    new Promise( _o_end1 => {
      global.c?.setState({
        sgcd_pagePntKeys: bf.p(global.c?.state.sgcd_pagePntKeys, _next => { // cmd20_key の初期化
          _next.cm20_key = '0'; // 全体共通
          _next.cm20c310 = '全体共通'; // 全体共通
        }),
      }, () => {
        _o_end1();
      });
    }),
    //
    new Promise( _o_end1 => {
      let _cnd = bf.q('');
      if (bf.f(global.c?.state.sgcd_schs.word)) {
        _cnd = bf.q('[cm20c310] LIKE "%{}%"'.f(global.c?.state.sgcd_schs.word)); // 非表示を含む全法人
      };            
      cf.myCB_set_items({
        ctr: 'nlm',
        elm: 'cm20',
        n_dms: 3,
        state: 'sld_cm20ss',
        cnd: _cnd,
        o_fnc: _d_cm20s => {
          return {
            pfx: '{cm20c310}'.f2(_d_cm20s),
          }
        }
      })
      .then(() => {
        _o_end1();
      });
    }),
  ];

  render() {
//      <ce.RootList
    return ( //  子で上書き
      <ce.RootDtl
        key={-1}
        b_logo={false}
        b_sch={true}
        onSchEnt={()=>{
          global.c.load();
        }}
        rhtIconName='plus'
        rhtPfx='新規'
        onRhtPrs={()=>{
          let _d_pageInfs = {
            sgc_pageRole: global.c?.state.sgc_pageRole,
            sgc_pageName: 'iCpyDtl',
            sgc_pageKey: '',
            sgc_pageMode: 'new',
            sgc_pagePrc: '',
            sgcb_pageEdt: true,
          };
          cf.myRN_move_fwd(_d_pageInfs);
        }}
        d_hdrs={{
          pfx: '',
          d_leftBtns: {},
        }}
        n_bdyW={ic.gn_w}
        d_bdys={{
          ld_defss: [
            {
              type: 'List',
              pfx: '',
              state: 'sld_cm20ss',
              nextRole: global.c?.state.sgc_pageRole,
              nextPage: 'iCpyDtl',
              pagePntKeyName: 'cm20_key',
              b_edt: false,
              b_img: false,
              b_bdr: false,
            },
          ],
        }}
      />
    );
  }
}

export default cCpyList;
